<template>
  <div v-loading="loading" class="verification">
    <div class="verification_content">
      <div class="verification_title">{{ $t($route.meta.title) }}</div>
      <div class="verification_main">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import LoginAPI from "../../api/LoginAPI";
import ApplicationAPI from "../../api/ApplicationAPI";
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
import { wordBreak } from "@/filters";
export default {
  data() {
    return {
      loading: false,
      spNo: null,
      serviceType: "",
    };
  },
  watch: {
    $route(val) {
      //   this.$router.push({
      //     query: { spNo: this.spNo }
      //   });
    },
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    apiType() {
      const serviceType = localStorage.getItem("serviceType") || null;
      switch (serviceType) {
        case "DRV_LIC_INTER":
          return "/driving";
        case "HZMB_CHANGE_PERSON":
        case "HZMB_CHANGE_COMP":
        case "HZMB_GH_CHANGE_COMP":
          return "/change";
        default:
          return "";
      }
    },
  },
  methods: {
    // 獲取服務類型詳情
    getServiceDetails(serviceType) {
      this.loading = true;
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          this.loading = false;
          res.nameTc = wordBreak(res.nameTc);
          res.nameSc = wordBreak(res.nameSc);
          res.namePt = wordBreak(res.namePt);
          res.nameEn = wordBreak(res.nameEn);
          this.$store.commit("changeServiceTypeConfig", res);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    accountLogin() {
      this.loading = true;
      const serviceType = localStorage.getItem("serviceType") || null;
      const token = sessionStorage.getItem("accountToken") || null;
      if (token) {
        LoginAPI.account(null, token, serviceType, false)
          .then((res) => {
            this.loading = false;
            localStorage.setItem("authentication", res.headers.authentication);
            this.$router.push("/search/status");
          })
          .catch((err) => {
            this.loading = false;
            // console.log(err);
            this.$error(err);
            this.$router.push("/search/personal");
          });
      }
    },
    logout() {
      this.loading = true;
      LoginAPI.logout()
        .then((res) => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    this.logout();
    localStorage.setItem("entryType", "search");
    this.$store.commit("changeViewType", "search");
    this.spNo =
      this.$route.query.spNo || localStorage.getItem("searchSpNo") || null;
    this.serviceType =
      this.$route.query.serviceType ||
      localStorage.getItem("serviceType") ||
      null;
    let changeType = null;
    if (
      [
        "HZMB_CHANGE_PERSON",
        "HZMB_CHANGE_COMP",
        "HZMB_GH_CHANGE_COMP",
      ].includes(this.serviceType)
    ) {
      changeType =
        this.$route.query.changeType ||
        localStorage.getItem("searchChangeType") ||
        null;
    }
    if (this.serviceType && this.spNo) {
      localStorage.setItem("searchSpNo", this.spNo);
      localStorage.setItem("serviceType", this.serviceType);
      if (changeType) {
        localStorage.setItem("searchChangeType", changeType);
      } else {
        localStorage.removeItem("searchChangeType");
      }
      const apiType = this.apiType;
      this.loading = true;
      ApplicationAPI.getBySpNo(this.serviceType, this.spNo, apiType, changeType)
        .then((res) => {
          this.loading = false;

          // 一戶通免登錄
          const accountToken = sessionStorage.getItem("accountToken") || null;
          if (res.authType == "ACCOUNT" && accountToken) {
            this.accountLogin();
            return;
          } else {
            localStorage.setItem("serviceType", res.serviceType);
            this.$store.commit("changeServiceType", res.serviceType);
            if (!res.applicationNo) {
              this.$message({
                message: this.$t("message.search_spNo_error"),
                type: "error",
              });
              return false;
            }
            this.$store.commit("changeSimpleData", res);
            this.$store.commit("changeVerifyForm", {
              type: "spNo",
              spNo: this.spNo,
              mobileAreaCode: [
                "HZMB_CHANGE_PERSON",
                "HZMB_CHANGE_COMP",
                "HZMB_GH_CHANGE_COMP",
              ].includes(res.serviceType)
                ? "853"
                : null,
              changeType,
            });
            if (
              res.serviceType == "HZMB_FIRST_COMPANY" ||
              res.serviceType == "HZMB_RENEW_COMPANY" ||
              res.serviceType == "HZMB_CHANGE_COMP" ||
              res.serviceType == "HZMB_GH_CHANGE_COMP"
            ) {
              this.$router.push("/search/company");
            } else if (
              res.serviceType == "HZMB_FIRST_PERSON" ||
              res.serviceType == "HZMB_RENEW_PERSON" ||
              res.serviceType == "HZMB_CHANGE_PERSON"
            ) {
              this.$router.push("/search/personal");
            }
          }

          this.getServiceDetails(res.serviceType);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
          // console.log(err);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.verification {
  max-width: 1048px;
  margin: 23px auto;
}
.verification_content {
  padding: 24px 5%;
  // background: rgba(237, 238, 246, 0.39);
  min-height: 500px;
}
.verification_title {
  font-size: 20px;
  color: #38959d;
  font-weight: 500;
  line-height: 28px;
  border-left: 4px solid #38959d;
  padding-left: 20px;
}
.verification_main {
  width: 100%;
  max-width: 600px;
  margin: 24px auto;
}
@media screen and (max-width: 767px) {
  .verification {
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
.submit_btn {
  text-align: center;
  margin: 76px 0;
}
</style>